import creditoService from '@/servicios/credito'
import { ERROR_CONSULTAR_BURO } from '@/utilidades/errores'

function extraerRechazoDeExcepcion(data) {
  try {
    const response = data && data.Modelo && data.Modelo.Response
    if (!response) return null
    const parsed =
      typeof response === 'string' ? JSON.parse(response) : response
    const entidad = parsed && parsed.Entidad
    if (entidad && entidad.Codigo === 404) {
      return entidad.Mensaje || 'Oferta cancelada'
    }
  } catch (e) {
    // No es el formato esperado, no se trata como rechazo de negocio
  }
  return null
}

export const ConsultaBuroMixin = {
  data: () => ({
    consumiendoConsultaBuro: false,
  }),
  methods: {
    // Metodos publicos
    consultaBuro(request = null) {
      this.$_ConsultaBuroMixin_IniciaConsultaBuro()
      creditoService
        .actualizacionBuro(request)
        .then((result) => {
          this.$_ConsultaBuroMixin_TerminaConsultaBuro()
          if (result.status != 200) {
            this.errorConsultaBuro(ERROR_CONSULTAR_BURO)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            const motivoRechazo = extraerRechazoDeExcepcion(data)
            if (motivoRechazo) {
              console.error(motivoRechazo)
              this.postConsultaBuro({
                aprobado: false,
                montoNuevo: 0,
                tasa: null,
                plazo: null,
              })
              return
            }
            console.error(data.Mensaje)
            this.errorConsultaBuro(ERROR_CONSULTAR_BURO)
            return
          }
          this.postConsultaBuro(data.Modelo)
        })
        .catch((err) => {
          this.$_ConsultaBuroMixin_TerminaConsultaBuro()
          console.error(err)
          this.errorConsultaBuro(ERROR_CONSULTAR_BURO)
        })
    },
    postConsultaBuro() {},
    errorConsultaBuro(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ConsultaBuroMixin_IniciaConsultaBuro() {
      this.consumiendoConsultaBuro = true
    },
    $_ConsultaBuroMixin_TerminaConsultaBuro() {
      this.consumiendoConsultaBuro = false
    },
  },
}
